// Select component for anyguide completely agnostic of the FormStore.
// For mobile devices a native <select /> is rendered. On web displays, we use
// the selectize plugin.
// When the select value changes the onChange prop is called. The component
// passes the new value on to the callback.
// Usage:
//   let options = [
//     {  text: 'Option1', value: '1' },
//     {  text: 'Option2', value: '2' }
//   ];
//   <Select options={options} value="1", onChange={function(value) {...}}} />
//
import React from 'react';
import PropTypes from 'prop-types';
import AppStore from 'stores/anyguide/app';
import NativeSelect from './native_select';
import SelectizeSelect from './selectize_select';
import { numberOrString } from 'lib/prop_types';

const isMobile = function () {
  return AppStore.getState().isMobile;
};

export default class Select extends React.Component {
  static displayName = 'Select';

  static propTypes = {
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    onChange: PropTypes.func.isRequired,
    value: numberOrString,
    className: PropTypes.string,
    selectizeOptions: PropTypes.object,
    disabled: PropTypes.bool,
    placeholder: PropTypes.string,
  };

  static defaultProps = {
    value: null,
    selectizeOptions: {},
    disabled: false,
    placeholder: '',
  };

  render() {
    if (isMobile()) {
      return <NativeSelect {...this.props} />;
    }
    return <SelectizeSelect {...this.props} />;
  }
}
